import axios from 'axios'
import qs from 'qs'

export async function getLocationAssignedUsers(locationId, params) {
    return axios
        .get(`${process.env.API_URL}/locations/${locationId}/users`, { params })
        .then(response => response.data)
}

export async function assingUserToLocation(locationId, users) {
    return axios
        .post(`${process.env.API_URL}/locations/${locationId}/users`, users)
        .then(response => response.data)
}

export async function deleteUserFromLocation(locationId, data) {
    return axios
        .delete(`${process.env.API_URL}/locations/${locationId}/users`, {
            data
        })
        .then(response => response.data)
}

export const getReportsForHeatmap = async params => {
    const { data } = await axios.get(`${process.env.API_URL}/heatmaps`, {
        params
    })
    return data
}

export async function fetchLocation(locationId) {
    return axios
        .get(`${process.env.API_URL}/locations/${locationId}`)
        .then(response => response.data)
}

export const fetchTasks = async locationId => {
    return axios
        .get(`${process.env.API_URL}/locations/tasks/${locationId}`)
        .then(response => response.data)
}

export const createTask = async taskData => {
    return axios
        .post(`${process.env.API_URL}/locations/tasks/`, taskData)
        .then(response => response.data)
}

export const updateTask = async (taskId, taskState) => {
    return axios
        .patch(`${process.env.API_URL}/locations/tasks/${taskId}`, {
            is_completed: taskState
        })
        .then(response => response.data)
}

export const getLastReportDate = async params => {
    return axios
        .get(`${process.env.API_URL}/reports/last-report`, {
            params
        })
        .then(response => response.data)
}

export const getNewBillingEscalationLevelsEmails = async params => {
    return axios
        .get(`${process.env.API_URL}/escalation-levels/verify-billing-emails`, {
            params,
            paramsSerializer: params => {
                return qs.stringify({ ...params })
            }
        })
        .then(response => response.data)
}

export const getLocationStatistics = async (
    locationId,
    reportType,
    includeSubLocations
) => {
    const params = {
        location_id: locationId,
        r_type: reportType
    }
    if (includeSubLocations) {
        params.w_s_l = 1
    }
    return axios
        .get(`${process.env.API_URL}/statistics`, {
            params,
            paramsSerializer: params => {
                return qs.stringify({ ...params })
            }
        })
        .then(response => response.data)
}
